import React from "react";
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import generalUtil from "../../../utils/generalUtils";
import Typography from "@mui/material/Typography";
import Rating from '@mui/material/Rating';
import { Link } from "gatsby";

const MentionedProducts = ({ strapiArticle }) => {

  const mentionedListings = _generateMentionedListings(strapiArticle);

  function _generateMentionedListings(articleData) {
    let listingsArray = [];
    if (articleData.productTags && articleData.productTags.length > 0) {
      articleData.productTags.forEach(function (listing) {
        listingsArray.push(listing);
      });
    }
    return listingsArray;
  }

  return (
    <>
      {mentionedListings != null && mentionedListings.length > 0 ? (
        <>
          <Typography
            variant="h2Side"
            sx={{
              mt: 2,
              ml: 2,
              mr: 2,
              mb: 3,
              color: "#606C7F",
              fontSize: "1.6rem",
              textAlign: "center",
              display: "block",
              font: "Raleway",
            }}
            data-testid="mentioned-products-title"
          >
            Mentioned Products
          </Typography>
        </>
      ) : (
        ""
      )}
      {mentionedListings.map((listing, index) => (
        <Card
          sx={{
            cursor: "pointer",
            maxHeight: 86,
            width: "100%",
            mt: 2,
            borderRadius: 5,
          }}
          data-productid={"P" + listing.strapi_id}
          data-testid={"P" + listing.strapi_id}
        >
          <Link
            id={"libraryMentionedSide" + index}
            to={listing.path}
            style={{ textDecoration: "none", color: "inherit" }}
            data-testid={"libraryMentionedSide" + index}
          >
            <Grid
              item
              container
              direction="row"
              alignItems="center"
              justifyContent="flex-start"
              rowSpacing={0}
            >
              <Grid item>
                <img
                  src={
                    listing.productLogo
                      ? generalUtil._cleanPortalURL(listing.productLogo.url)
                      : generalUtil._cleanImages(listing.productLogoURL)
                  }
                  alt={listing.name + "Profile Image"}
                  style={{
                    zIndex: 2,
                    marginBottom: 0,
                    backgroundColor: "white",
                    width: 86,
                    height: 86,
                    objectFit: "cover",
                  }}
                />
              </Grid>
              <Grid item container direction="column" xs={7} sm={8}>
                <Grid item>
                  <Typography variant="h5ProductListing">
                    {listing.name}
                  </Typography>
                </Grid>
                {listing.overallRating ? (
                  <Grid item>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        textAlign: "center",
                      }}
                    >
                      <Rating
                        name="read-only"
                        value={listing.overallRating}
                        readOnly
                        precision={0.5}
                        size="small"
                      />
                      <Typography variant="h8b">
                        ({listing.numberOfReviews})
                      </Typography>
                    </div>
                  </Grid>
                ) : (
                  ""
                )}
              </Grid>
            </Grid>
          </Link>
        </Card>
      ))}
    </>
  );
};
export default MentionedProducts;
